module.exports = __webpack_public_path__ + "95065e55aa5ef937a33fe100e4fa9f51.svg";